var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "contents" } }, [
    _c("div", { staticClass: "inner detail-top user-preview" }, [
      _c("div", { staticClass: "clear" }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "company-area" }, [
        _c("h1", { staticClass: "fs16 hd-type-02 company-title" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm.companyName) +
              "（サンプル［ここに実際の募集職種名が入ります］）の面接対策・選考情報\n      "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "contents-inner clearfix mb30" }, [
        _c("section", { staticClass: "mlr10" }, [
          _c("div", [
            _c(
              "h2",
              {
                staticClass: "fs14 fwB",
                staticStyle: { "line-height": "1.6" },
              },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.companyName) +
                    "「サンプル［ここに実際の募集職種名が入ります］」の面接対策や選考情報が調べられ、企業研究になるページです。中途採用の流れや面接時に質問されやすい項目などを事前に確認することで面接内容について対策が出来ます。\n          "
                ),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "pt20 mlr10" }, [
          _vm._m(1),
          _vm._v(" "),
          _c("article", [
            _c("div", { staticClass: "details clearfix" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "detail-right" }, [
                _c("p", {
                  attrs: { "data-test": "company-name" },
                  domProps: { textContent: _vm._s(_vm.companyName) },
                }),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(3),
            _vm._v(" "),
            _c("div", { staticClass: "details clearfix" }, [
              _vm._m(4),
              _vm._v(" "),
              _c("div", { staticClass: "detail-right" }, [
                _c("p", {
                  attrs: { "data-test": "paper-screening-label" },
                  domProps: { textContent: _vm._s(_vm.paperScreeningLabel) },
                }),
                _vm._v(" "),
                _vm.jobInterview.paperScreeningRemarks
                  ? _c("p", {
                      staticClass: "mt15",
                      attrs: { "data-test": "paper-screening-remarks" },
                      domProps: {
                        textContent: _vm._s(
                          _vm.jobInterview.paperScreeningRemarks
                        ),
                      },
                    })
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "details clearfix" }, [
              _vm._m(5),
              _vm._v(" "),
              _c("div", { staticClass: "detail-right" }, [
                _c("p", {
                  attrs: { "data-test": "spi-label" },
                  domProps: { textContent: _vm._s(_vm.spiLabel) },
                }),
                _vm._v(" "),
                _vm.jobInterview.spiTestRemarks
                  ? _c("p", {
                      staticClass: "mt15",
                      attrs: { "data-test": "spi-remarks" },
                      domProps: {
                        textContent: _vm._s(_vm.jobInterview.spiTestRemarks),
                      },
                    })
                  : _vm._e(),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "mlr10 mt30" }, [
          _vm._m(6),
          _vm._v(" "),
          _c("section", [
            _c("div", [
              _c(
                "p",
                {
                  staticClass: "fs13 mt20 mb20",
                  staticStyle: { "line-height": "1.6" },
                  attrs: { "data-test": "interview-information-description" },
                },
                [
                  _vm._v(
                    "\n              1次面接や役員面接、最終面接など、" +
                      _vm._s(_vm.companyName) +
                      "の中途採用面接について紹介します。\n            "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("article", [
            _c("div", { staticClass: "details clearfix" }, [
              _vm._m(7),
              _vm._v(" "),
              _c("div", { staticClass: "detail-right" }, [
                _c("p", {
                  attrs: { "data-test": "content" },
                  domProps: { textContent: _vm._s(_vm.jobInterview.content) },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "details clearfix" }, [
              _vm._m(8),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-right" },
                [
                  _vm._l(
                    _vm.jobInterview.interviewers,
                    function (interviewer, i) {
                      return [
                        _vm.jobInterview.interviewers.length > 1
                          ? _c("p", {
                              key: "interviewer-label-" + interviewer.no,
                              staticClass: "stage fwB",
                              class: { mt15: i > 0 },
                              attrs: { "data-test": "interviewer-label-" + i },
                              domProps: {
                                textContent: _vm._s(interviewer.no + "次選考"),
                              },
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isSelectionType(interviewer)
                          ? [
                              _c("p", {
                                key: "interviewer-detail-" + interviewer.no,
                                attrs: {
                                  "data-test": "interviewer-detail-" + i,
                                },
                                domProps: {
                                  textContent: _vm._s(
                                    _vm.getInterviewLabel(interviewer)
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              interviewer.remarksOrFreeText
                                ? _c(
                                    "dl",
                                    {
                                      key:
                                        "interviewer-remarks-" + interviewer.no,
                                      staticClass: "bg-blue-box p15 mt10",
                                      attrs: {
                                        "data-test": "interviewer-remarks-" + i,
                                      },
                                    },
                                    [
                                      _c("dd", [
                                        _vm._v(
                                          _vm._s(interviewer.remarksOrFreeText)
                                        ),
                                      ]),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          : [
                              _c("p", {
                                key: "interviewer-remarks-" + interviewer.no,
                                attrs: {
                                  "data-test": "interviewer-remarks-" + i,
                                },
                                domProps: {
                                  textContent: _vm._s(
                                    interviewer.remarksOrFreeText
                                  ),
                                },
                              }),
                            ],
                      ]
                    }
                  ),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.requiredTimeLabel || _vm.jobInterview.requiredTimeRemarks
              ? _c(
                  "div",
                  {
                    staticClass: "details clearfix",
                    attrs: { "data-test": "required-time" },
                  },
                  [
                    _vm._m(9),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-right" }, [
                      _vm.requiredTimeLabel
                        ? _c("p", {
                            staticClass: "opportunity mb15",
                            attrs: { "data-test": "required-time-label" },
                            domProps: {
                              textContent: _vm._s(_vm.requiredTimeLabel),
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.jobInterview.requiredTimeRemarks
                        ? _c("p", {
                            attrs: { "data-test": "required-time-remarks" },
                            domProps: {
                              textContent: _vm._s(
                                _vm.jobInterview.requiredTimeRemarks
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.clothLabel || _vm.jobInterview.clothRemarks
              ? _c(
                  "div",
                  {
                    staticClass: "details clearfix",
                    attrs: { "data-test": "cloth" },
                  },
                  [
                    _vm._m(10),
                    _vm._v(" "),
                    _c("div", { staticClass: "detail-right" }, [
                      _vm.clothLabel
                        ? _c("p", {
                            staticClass: "fashion mb15",
                            attrs: { "data-test": "cloth-label" },
                            domProps: { textContent: _vm._s(_vm.clothLabel) },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.jobInterview.clothRemarks
                        ? _c("p", {
                            attrs: { "data-test": "cloth-renarks" },
                            domProps: {
                              textContent: _vm._s(
                                _vm.jobInterview.clothRemarks
                              ),
                            },
                          })
                        : _vm._e(),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "mlr10 mt30" }, [
          _c("div", { staticClass: "hd-type-03" }, [
            _c(
              "h3",
              { attrs: { id: "about", "data-test": "importance-point-title" } },
              [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.companyName) +
                    "の面接対策ポイント\n          "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("section", [
            _c("div", [
              _c(
                "p",
                {
                  staticClass: "fs13 mt20 mb20",
                  staticStyle: { "line-height": "1.6" },
                  attrs: { "data-test": "importance-point-description" },
                },
                [
                  _vm._v(
                    "\n              コミュニケーション能力、仕事への意欲など、" +
                      _vm._s(_vm.companyName) +
                      "が面接時に重要視しているポイントが分かります。\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "clearfix" }, [
                _c("div", { staticClass: "rating-block fll" }, [
                  _c("div", { staticClass: "rating-left" }, [
                    _c(
                      "ul",
                      [
                        _c("interview-preview-importance-point", {
                          attrs: {
                            label: "business",
                            value: _vm.jobInterview.businessManner,
                          },
                        }),
                        _vm._v(" "),
                        _c("interview-preview-importance-point", {
                          attrs: {
                            label: "communication",
                            value: _vm.jobInterview.communicationAbility,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "rating-block flr" }, [
                  _c("div", { staticClass: "rating-right" }, [
                    _c(
                      "ul",
                      [
                        _c("interview-preview-importance-point", {
                          attrs: {
                            label: "skill",
                            value: _vm.jobInterview.skill,
                          },
                        }),
                        _vm._v(" "),
                        _c("interview-preview-importance-point", {
                          attrs: {
                            label: "ｍotivation",
                            value: _vm.jobInterview.motivation,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "mlr10 mt30" }, [
          _vm._m(11),
          _vm._v(" "),
          _c("section", [
            _c("div", [
              _c(
                "p",
                {
                  staticClass: "fs13 mt20 mb20",
                  staticStyle: { "line-height": "1.6" },
                  attrs: { "data-test": "about-interview-description" },
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.companyName) +
                      "の採用面接の過去の質問例などを紹介します。\n            "
                  ),
                ]
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("article", [
            _c("div", { staticClass: "details clearfix" }, [
              _vm._m(12),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "detail-right" },
                [
                  _vm._l([1, 2, 3], function (index) {
                    return [
                      _vm.jobInterview["question" + index]
                        ? [
                            _vm.existsQuestionTwoOrThree
                              ? _c(
                                  "span",
                                  {
                                    key: "label-" + index,
                                    staticClass: "point fs12",
                                    attrs: {
                                      "data-test":
                                        "question" + index + "-label",
                                    },
                                  },
                                  [_vm._v("質問例0" + _vm._s(index))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("p", {
                              key: index,
                              attrs: {
                                "data-test": "question" + index + "-text",
                              },
                              domProps: {
                                textContent: _vm._s(
                                  _vm.jobInterview["question" + index]
                                ),
                              },
                            }),
                          ]
                        : _vm._e(),
                    ]
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _vm.welcomeQuestionLabels.length > 0
              ? _c(
                  "div",
                  {
                    staticClass: "details clearfix",
                    attrs: { "data-test": "welcome-questions" },
                  },
                  [
                    _vm._m(13),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "detail-right question-example" },
                      [
                        _c(
                          "ul",
                          { staticClass: "question-example-ul" },
                          _vm._l(_vm.welcomeQuestionLabels, function (item, i) {
                            return _c("li", {
                              key: "welcome-question-" + i,
                              staticClass: "question-example-li",
                              attrs: { "data-test": "welcome-questions-item" },
                              domProps: { textContent: _vm._s(item.name) },
                            })
                          }),
                          0
                        ),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "mlr10 viewpoints mt30" }, [
          _c(
            "h4",
            {
              staticClass: "fs14 fwB tc interview",
              attrs: { "data-test": "message-title" },
            },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.companyName) +
                  "からのメッセージ\n        "
              ),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "fs13 p20 interview-row" }, [
            _c("p", {
              attrs: { "data-test": "message" },
              domProps: { textContent: _vm._s(_vm.jobInterview.message) },
            }),
          ]),
        ]),
        _vm._v(" "),
        _c("section", { staticClass: "mlr10 mt30" }, [
          _vm._m(14),
          _vm._v(" "),
          _c("article", [
            _c("div", { staticClass: "details clearfix" }, [
              _vm._m(15),
              _vm._v(" "),
              _c("div", { staticClass: "detail-right" }, [
                _c("p", {
                  attrs: { "data-test": "company-name-buttom" },
                  domProps: { textContent: _vm._s(_vm.companyName) },
                }),
              ]),
            ]),
            _vm._v(" "),
            _vm._m(16),
          ]),
        ]),
        _vm._v(" "),
        _vm._m(17),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "ul",
      {
        staticClass: "mt30 fs13 detail-menu",
        attrs: { "data-test": "preview-tab" },
      },
      [
        _c("a", [_c("li", [_vm._v("募集情報")])]),
        _vm._v(" "),
        _c("span", [_c("li", { staticClass: "active" }, [_vm._v("面接情報")])]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hd-type-03" }, [
      _c("h3", { attrs: { id: "description" } }, [
        _vm._v("\n            応募職種概要\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("会社名")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details clearfix" }, [
      _c("div", { staticClass: "detail-left" }, [
        _c("h4", [_vm._v("募集職種名")]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-right" }, [
        _c("p", [_vm._v("サンプル［ここに実際の募集職種名が入ります］")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("書類選考")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("適性検査の有無")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hd-type-03" }, [
      _c("h3", { attrs: { id: "require" } }, [
        _vm._v("\n            面接の選考情報\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("面接内容")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("面接官について")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("所要時間")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("面接時の服装/持ち物")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hd-type-03" }, [
      _c("h3", { attrs: { id: "oldies" } }, [
        _vm._v("\n            過去の中途面接について\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("過去の面接であった質問")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("右記項目についての質問歓迎です")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hd-type-03" }, [
      _c("h3", { attrs: { id: "company" } }, [
        _vm._v("\n            会社概要\n          "),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "detail-left" }, [
      _c("h4", [_vm._v("会社名")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "details clearfix" }, [
      _c("div", { staticClass: "detail-left" }, [_c("h4", [_vm._v("企業HP")])]),
      _vm._v(" "),
      _c("div", { staticClass: "detail-right" }, [
        _c("a", [
          _vm._v(
            "https://*******.jp［ここに実際の企業ホームページURLが入ります］"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "caution mb15 mlr10" }, [
      _c("p", { staticClass: "fwB" }, [
        _vm._v(
          "\n          この面接対策・選考情報ページは掲載スタート時の情報となります。"
        ),
        _c("br"),
        _vm._v(
          "掲載企業の選考状況などにより、内容が変更となる場合もありますので、ご了承くださいませ。\n        "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }